import { getRandomUUID } from "../../Token";
import {
  getBillingAccounts,
  fetchLicensesForAccount,
  listFovByLicenseEndPoint,
  resumeLicenseEndPoint,
  suspendLicenseEndPoint,
} from "../../configuration";
import axiosInstance from "../../global/axiosInterceptor";
import { handleApiError } from "../../global/utility/Utils";

export const fetchBillingAccountsData = async () => {
  try {
    const response = await axiosInstance.get(getBillingAccounts());
    const resData = response.data;
    if (response.status === 200) {
      return resData.currenttenancy.billingaccountids;
    }
  } catch (error) {
    console.log("Error while getting Billing Account -> " + error);
    return [];
  }
};

export const fetchLicensesOfAccount = async (accountId) => {
  try {
    const response = await axiosInstance.post(fetchLicensesForAccount(), {
      accountname: accountId,
    });
    const resData = response.data;
    if (response.status === 200) {
      return resData;
    }
  } catch (error) {
    console.log("Error while getting Billing Account -> " + error);
    handleApiError("warning", "Fetching Data Failed, please reload the page");
    return [];
  }
};

export const fetchFovByLicense = async(accountId,sku)=>{
  
  try {
    const response = await axiosInstance.post(listFovByLicenseEndPoint(), {
      accountname: accountId,
      sku: sku
    });
    const resData = response.data;
    if (response.status === 200) {
      return resData;
    }
  } catch (error) {
    console.log("Error while getting FOV by License -> " + error);
    throw error;
  }
}

 export const suspendLicense = async (accountId, deviceId, sku) => {
     const response = await axiosInstance.post(
       suspendLicenseEndPoint(), {
         accountname: accountId,
         deviceidentifier: {
           deviceid: deviceId
         },
         sku: sku
       }
    );
     return response;
 };

export const resumeLicense = async (accountId, deviceId, sku) => {
    const response = await axiosInstance.post(
      resumeLicenseEndPoint(), {
        accountname: accountId,
        deviceidentifier: {
          deviceid: deviceId
        },
        sku: sku
      }
    );
    return response;
};
